var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:[
    'text-primary fs-12',
    {'pointer-events-none green--text': _vm.isCopied},
    'copy-button'
  ],attrs:{"color":"#E9E9F0","depressed":"","small":""},on:{"click":function($event){return _vm.copyApiKeyToClipboard(_vm.text)}}},[_c('v-icon',{class:['mr-1', _vm.isCopied ? 'green--text'  : 'text-gray'],attrs:{"size":"16","data-test":"icon-copy"}},[_vm._v(" "+_vm._s(_vm.isCopied ? 'mdi-check' : 'mdi-content-copy')+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }